import { render, staticRenderFns } from "./component-manage.vue?vue&type=template&id=b455366e&scoped=true"
import script from "./component-manage.vue?vue&type=script&lang=js"
export * from "./component-manage.vue?vue&type=script&lang=js"
import style0 from "./component-manage.vue?vue&type=style&index=0&id=b455366e&prod&lang=scss"
import style1 from "./component-manage.vue?vue&type=style&index=1&id=b455366e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b455366e",
  null
  
)

export default component.exports